<div pl-grid-el pl-grid="1/1@phone">
  <h2 class="myse-dashboard__section-title" [textContent]="'DASHBOARD.SCHEDULE.title' | translate"></h2>
  <a
    (click)="fireAnalytics()"
    [routerLink]="['schedule']"
    class="myse-dashboard__section-link"
    [textContent]="'EVENT_LIST.see_all' | translate"
    >
  </a>
</div>

<div pl-grid-el pl-grid="1/1@phone">
  @if (!loaded && !failed) {
    <div
    class="myse-dashboard-skeleton--section-card myse-dashboard__full-card se-card"></div>
  }
  @if (failed) {
    <se-fe-card class="myse-dashboard__full-card myse-dashboard__compact-card">
      <se-fe-card-content>
        <se-fe-empty-state seFeDataTitle="{{ 'DASHBOARD.SCHEDULE_FAILED.title' | translate }}" seFeDataSize="500">
          <se-fe-button seFeEmptyStateAction seFeDataEmphasis="high" (click)="load()">{{ 'DASHBOARD.SCHEDULE_FAILED.action' | translate }}</se-fe-button>
        </se-fe-empty-state>
      </se-fe-card-content>
    </se-fe-card>
  }

  @if (loaded && !failed && events.length === 0) {
    <se-fe-card
      class="myse-dashboard__full-card myse-dashboard__compact-card">
      <se-fe-card-content>
        <se-fe-empty-state seFeDataTitle="{{ 'DASHBOARD.SCHEDULE_EMPTY.title' | translate }}" seFeDataSize="500">
          {{ 'DASHBOARD.SCHEDULE_EMPTY.description' | translate }}
        </se-fe-empty-state>
      </se-fe-card-content>
    </se-fe-card>
  }

  @if (loaded && !failed && events.length > 0) {
    @for (day of days; track day; let isLast = $last) {
      <div
        pl-grid-el
        pl-grid="1/1@phone"
        class="myse-event__day-container">
        <div class="myse-event__day-label">
          <app-date-stamp [dateString]="day.day"></app-date-stamp>
        </div>
        <div class="myse-event__day-grouping">
          @for (event of day.events; track event) {
            <div
              class="event-class-for-event">
              @if (event.emptyMessage) {
                <se-fe-empty-state seFeDataTitle="{{ event.emptyMessage }}" seFeDataSize="500">
                </se-fe-empty-state>
              }
              @if (!event.emptyMessage) {
                <app-event-card [dataEvent]="event" (onRsvp)="onRsvp($event)"></app-event-card>
              }
            </div>
          }
        </div>
      </div>
    }
  }
</div>


